<template>
  <div>
    <!-- {{ materials }} -->
    <div v-if="materials">
      <div v-if="parseInt(materials.any)">Available in most materials</div>
      <div v-else-if="hasMaterials || hasMaterialCompanies">
        <div v-if="hasMaterialCompanies" class="mb-2">
          <div class="overline">Materials from:</div>
          <v-btn
            text
            small
            color="primary"
            v-for="companyId in materials.companies"
            :key="companyId"
            width="150"
            @click="showCompanyMaterials(companyId)"
          >
            {{ companyNameForId(companyId) }}
          </v-btn>
        </div>
        <div v-if="hasMaterials" class="mb-2">
          <div v-if="hasMaterialCompanies" class="overline">Materials:</div>
          <v-btn
            text
            small
            color="primary"
            v-for="materialId in materials.materials"
            :key="materialId"
            @click="showDetailsDialog(materialId)"
            width="150"
          >
            {{ materialNameForId(materialId) }}
            <!-- <v-icon x-small color="primary">mdi-information-outline</v-icon> -->
          </v-btn>
        </div>
      </div>
      <div v-else>Material Options Unknown</div>
    </div>

    <v-dialog
      v-model="companyDialog"
      max-width="500"
      scrollable
      :loading="dialogLoading"
    >
      <v-card>
        <v-card-title
          class="d-flex flex-row align-start"
          v-if="companyDetailId"
        >
          <div class="text-h5">
            {{ companyNameForId(companyDetailId) }}
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="companyDialog = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle>Click a material to see its details</v-card-subtitle>

        <v-card-text v-if="rgpOptions">
          <!-- <v-data-table :items="filteredMaterials"></v-data-table> -->
          <v-btn
            text
            small
            color="primary"
            v-for="materialId in rgpOptions.materialsByCompany[companyDetailId]"
            :key="'m2' + materialId"
            @click="showDetailsDialog(materialId)"
            width="150"
          >
            {{ materialNameForId(materialId) }}
            <!-- <v-icon x-small color="primary">mdi-information-outline</v-icon> -->
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="detailsDialog" max-width="350" scrollable>
      <div v-if="materialDetails && rgpOptions">
        <material-detail-card
          :materialData="materialDetails"
          :rgpOptions="rgpOptions"
          @close="detailsDialog = false"
        ></material-detail-card>
      </div>
    </v-dialog>
  </div>
</template>

<script>
// import Name from "../dir/file";
import RgpOptionsMixin from "@/assets/js/rgps/RgpOptionsMixin.js";

export default {
  name: "MaterialSummary",
  props: {
    materials: null,
    rgpOptions: null,
    materialList: null,
  },
  components: {
    MaterialDetailCard: () => import("@/components/gpStuff/MaterialDetailCard"),
  },
  mixins: [RgpOptionsMixin],
  data: function () {
    return {
      dialogLoading: true,
      companyDialog: false,
      detailsDialog: false,
      companyDetails: null,
      //   materialDetails: null,
      companyDetailId: null,
      materialDetailId: null,
    };
  },
  methods: {
    // materialCompanyNameForId() -> in mixin
    materialClick(id) {
      console.log(id);
    },
    companyClick(id) {
      console.log(id);
    },
    showCompanyMaterials(id) {
      this.companyDetailId = id;
      this.companyDialog = true;
    },
    showDetailsDialog(id) {
      this.detailsDialog = true;
      if (!this.materialList) {
        this.$emit("getMaterialList");
        this.dialogLoading = true;
      }
      this.materialDetailId = id;
    },
  },
  computed: {
    hasMaterials: function () {
      return this.materials.materials && this.materials.materials.length;
    },
    hasMaterialCompanies: function () {
      return this.materials.companies && this.materials.companies.length;
    },
    materialDetails: function () {
      if (!this.materialDetailId || !this.materialList?.meta) return;
      //   console.log("id", this.materialDetailId);
      //   console.log(this.materialList.items[this.materialDetailId]);
      let idx = this.materialList.meta.byId[this.materialDetailId];
      return this.materialList.items[idx];
    },
  },
  watch: {
    materialList: {
      handler(val) {
        if (val && val.items) {
          this.dialogLoading = false;
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.materialDiv {
  width: 200px;
}
</style>
